<template>
  <div v-if="messageType === CraftingQueueStatusMessage.COMMON_QUEUE_OVERLOAD" class="queue-overloaded-content">
    <span>{{ $t('craftingTotalRecipeLimitText1') }}</span>
    <span>
      <el-skeleton :loading="maxQueuePerUserData.isLoading.value" animated>
        <template #template>
          <el-skeleton-item style="height: 20px" />
        </template>
        <template #default>
          <span class="limit-reached-red">{{ currentRecipe?.maxQueue }}</span
          >/<span class="limit-reached-grey">{{ currentRecipe?.maxQueue }}</span>
        </template>
      </el-skeleton>
    </span>
    <span>{{ $t('craftingTotalRecipeLimitText2') }}</span>
    <p style="display: inline" v-html="$t('craftingQueueLimitExceeded2')" />
  </div>

  <div v-else class="queue-overloaded-content">
    <span>{{ $t('craftingPersonalRecipeLimitText1') }}</span>
    <span>
      <el-skeleton :loading="maxQueuePerUserData.isLoading.value" animated>
        <template #template>
          <el-skeleton-item style="height: 20px" />
        </template>
        <template #default>
          <span class="limit-reached-red">{{ maxQueuePerUserData.maxQueuePerUser }}</span
          >/<span class="limit-reached-grey">{{ maxQueuePerUserData.maxQueuePerUser }}</span>
        </template>
      </el-skeleton>
    </span>
    <span>{{ $t('craftingPersonalRecipeLimitText2') }}</span>
    <p style="display: inline" v-html="$t('craftingPersonalQueueLimitExceeded2')" />
  </div>
</template>
<script setup lang="ts">
import { CraftingQueueStatusMessage } from '~/utils/constants';
import type { BuildingProps, RecipeProps } from '~/types/crafting';

const building = inject<Ref<BuildingProps>>('building');
const currentRecipe = inject<Ref<RecipeProps>>('currentRecipe');

defineProps<{
  messageType: CraftingQueueStatusMessage;
}>();

console.log('building: ', building);

const { data: recipeToCraft } = useNuxtData<RecipeProps>('recipes/recipe');
const maxQueuePerUserData = await useMaxQueuePerUser(recipeToCraft, building);
</script>

<style lang="scss" scoped>
.limit-reached-red {
  font-weight: 700;
  font-size: 20px;
  color: #f6164c;
}

.limit-reached-grey {
  font-weight: 400;
  font-size: 16px;
  color: #ffffff80;
}
</style>
<style lang="scss">
.queue-overloaded-content {
  p span {
    color: var(--blue_highlight);
  }
}
</style>
